import React from 'react';

import { TextField } from '@mui/material';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateInputProps } from '../types';

const DatePicker = (props: DateInputProps) => {
    const {
        onChange,
        value,
        label,
        maxDate,
        minDate,
        fieldError,
        helperText,
        disabled,
    } = props;
    return (
        <MUIDatePicker
            label={label}
            maxDate={maxDate}
            minDate={minDate}
            value={value || ''}
            onChange={onChange}
            disabled={disabled}
            renderInput={(params) => (
                <TextField
                    fullWidth
                    size="small"
                    {...params}
                    error={fieldError}
                    helperText={helperText}
                    InputLabelProps={{ shrink: true }}
                />
            )}
        />
    );
};

DatePicker.defaultProps = {
    minDate: undefined,
    maxDate: undefined,
    helperText: '',
    fieldError: false,
    required: false,
    disabled: false,
};

export default DatePicker;
